package com.klantenstop.web.pages.authentication.verifyEmail

import com.klantenstop.web.data.models.domain.VerificationStatus
import com.klantenstop.web.utils.MVI

interface VerifyEmailContract : MVI<VerifyEmailContract.State, VerifyEmailContract.Intent, VerifyEmailContract.Effect> {
    data class State(
        val code: String,
        val verificationStatus: VerificationStatus = VerificationStatus.Verifying
    )

    sealed class Intent {
        data object VerifyCode : Intent()
        data object ResendVerification : Intent()
        data object NavigateToHome : Intent()
    }

    sealed class Effect {
        data object NavigateToHome : Effect()
    }
}

